module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "loading": _vm.gettingTests,
      "pagination": _vm.testHistoryPagination,
      "items": _vm.tests,
      "headers": [{
        text: 'Test Date',
        value: 'time'
      }, {
        text: 'Last Update',
        value: 'formattedLastUpdate'
      }, {
        text: 'Name',
        value: 'tester'
      }]
    },
    on: {
      "update:pagination": function($event) {
        _vm.testHistoryPagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              return _vm.setActiveTest(props.item)
            }
          }
        }, [_c('td', {
          class: props.item.UID === _vm.activeTest ? 'info' : ''
        }, [_vm._v(_vm._s(props.item.date))]), _vm._v(" "), _c('td', {
          class: props.item.UID === _vm.activeTest ? 'info' : ''
        }, [_vm._v(_vm._s(props.item.formattedLastUpdate))]), _vm._v(" "), _c('td', {
          class: props.item.UID === _vm.activeTest ? 'info' : ''
        }, [_vm._v(_vm._s(props.item.tester))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "ID type",
      "return-object": "",
      "items": _vm.IDSelections,
      "item-text": "name",
      "dense": ""
    },
    model: {
      value: (_vm.IDType),
      callback: function($$v) {
        _vm.IDType = $$v
      },
      expression: "IDType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "number",
      "label": _vm.IDType.name,
      "dense": ""
    },
    model: {
      value: (_vm.ID),
      callback: function($$v) {
        _vm.ID = $$v
      },
      expression: "ID"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "loading": _vm.gettingResults,
      "disabled": _vm.ID.length < 5
    },
    on: {
      "click": _vm.testDevice
    }
  }, [_vm._v("\n        TEST NOW\n      ")])], 1), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.error.length > 0,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.results.LastUpdate) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('p', [_vm._v("Check connected in the last from check date.")]), _vm._v(" "), _c('v-select', {
    ref: "connectedSince",
    staticClass: "mb-0 pb-0",
    attrs: {
      "label": "Custom",
      "items": _vm.connectedSinceItems,
      "hint": _vm.selectionHint,
      "persistent-hint": "",
      "solo": "",
      "prepend-icon": "mdi-calendar"
    },
    on: {
      "click:prepend": function($event) {
        _vm.dateModal = true
      },
      "change": function($event) {
        _vm.selectionHint = ''
      }
    },
    model: {
      value: (_vm.connectedSince),
      callback: function($$v) {
        _vm.connectedSince = $$v
      },
      expression: "connectedSince"
    }
  }), _vm._v(" "), _c('v-dialog', {
    ref: "dialog",
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": "",
      "width": "290px"
    },
    model: {
      value: (_vm.dateModal),
      callback: function($$v) {
        _vm.dateModal = $$v
      },
      expression: "dateModal"
    }
  }, [_c('v-card', [_c('v-date-picker', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "scrollable": "",
      "no-title": ""
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "mx-5",
    attrs: {
      "label": "Time",
      "type": "time",
      "mask": "time",
      "outline": ""
    },
    model: {
      value: (_vm.time),
      callback: function($$v) {
        _vm.time = $$v
      },
      expression: "time"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dateModal = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": _vm.setCustomDate
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("Vehicle Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.LastUpdate) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.LastUpdate) ? 'check' : 'close')
    }
  }), _vm._v(_vm._s(_vm._f("formatDate")(_vm.results.LastUpdate)))], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Reg")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.Registration))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Friendly Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.FriendlyName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle Group")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.VehicleGroup))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Address")]), _vm._v(" "), _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.results.Address)
    }
  })]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Vehicle State")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.VehicleState))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("GPS Fix")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.results.GPSFix > 5 ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.results.GPSFix > 5 ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ignition On")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.IgnitionOn) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.IgnitionOn) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Ignition Off")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.IgnitionOff) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.IgnitionOff) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("IMEI")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.IMEI))])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("CAN Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("SQ EON")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQEon) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQEon) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SQ EOFF")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQEoff) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQEoff) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SQ D8")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQTacho) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQTacho) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("SQ 1 Minute")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.SQ30sNIBC) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.SQ30sNIBC) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Odometer")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.Odometer))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Fuel")]), _vm._v(" "), _c('td', [(_vm.results.FuelLevel) ? _c('span', [_vm._v(_vm._s(_vm.results.FuelLevel))]) : _c('v-icon', {
    attrs: {
      "large": "",
      "color": "error"
    },
    domProps: {
      "innerHTML": _vm._s('close')
    }
  })], 1)])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("Tacho Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("Driver Name")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.TachoSysDriverName))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("DDS Message Updated")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.TachoSysMessageUpdated) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.TachoSysMessageUpdated) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("TachoSys Card Number")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.TachoSysCardNumber))])])])])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md3": ""
    }
  }, [_c('h3', {
    staticClass: "subheading grey--text"
  }, [_vm._v("DVR Section")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("DVR ID")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.results.DVRID))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ACC Ignition On")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.ACCIgnitionOnDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.ACCIgnitionOnDateTime) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Device Online")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.DeviceOnlineDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.DeviceOnlineDateTime) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("GSM Dial Up OK")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.GSMDialUpOKDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.GSMDialUpOKDateTime) ? 'check' : 'close')
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("HDD Write OK")]), _vm._v(" "), _c('td', [_c('v-icon', {
    attrs: {
      "large": "",
      "color": _vm.compareDate(_vm.results.HDDWriteOKDateTime) ? 'success' : 'error'
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compareDate(_vm.results.HDDWriteOKDateTime) ? 'check' : 'close')
    }
  })], 1)])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.notesDialog = true
      }
    }
  }, [_vm._v("Additional information")])], 1), _vm._v(" "), (_vm.results.ICCID) ? _c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Select Test Message",
      "items": _vm.messageTemplates
    },
    model: {
      value: (_vm.message),
      callback: function($$v) {
        _vm.message = $$v
      },
      expression: "message"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": _vm.message.length < 1,
      "loading": _vm.sendingMessage
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v("Send Message")])], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.notesDialog),
      callback: function($$v) {
        _vm.notesDialog = $$v
      },
      expression: "notesDialog"
    }
  }, [_c('v-card', {
    staticClass: "pa-2"
  }, [_c('v-card-title', [_vm._v("Use this to record any notes/images against this test.")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Notes"
    },
    model: {
      value: (_vm.extraNotes),
      callback: function($$v) {
        _vm.extraNotes = $$v
      },
      expression: "extraNotes"
    }
  }), _vm._v(" "), _c('v-list', _vm._l((_vm.uploadedFiles), function(file, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": file.downloadUrl
      }
    }, [_vm._v(_vm._s(file.name))])])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-list', _vm._l((_vm.fileList), function(file, i) {
    return _c('v-list-tile', {
      key: i
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "error"
      },
      on: {
        "click": function($event) {
          return _vm.fileList.splice(i, 1)
        }
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(file.name))])], 1)], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$refs.fileInput.click()
      }
    }
  }, [_vm._v("Add File(s)")]), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "hidden": "",
      "multiple": "",
      "type": "file"
    },
    on: {
      "change": _vm.addFiles
    }
  }), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.notesDialog = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary",
      "loading": _vm.savingNotes
    },
    on: {
      "click": _vm.saveExtraDetails
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "success",
      "timeout": 2000
    },
    model: {
      value: (_vm.notesSaved),
      callback: function($$v) {
        _vm.notesSaved = $$v
      },
      expression: "notesSaved"
    }
  }, [_vm._v("\n    Details Saved\n    "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.notesSaved = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eecc1c3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Testing.vue
// module id = 759
// module chunks = 1